import React from "react";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import "./date-changer.css";

const DateChanger = ({ date, onChange }) => {
  return (
    <div className="date-changer-container">
      <div onClick={onChange.bind(null, -1)} className="date-changer-arrow-bg">
        <LeftOutlined />
      </div>
      <div className="date-changer-date">{date}</div>
      <div onClick={onChange.bind(null, 1)} className="date-changer-arrow-bg">
        <RightOutlined />
      </div>
    </div>
  );
};

export default DateChanger;
